module.exports = __webpack_public_path__ + "public/SiteImages/angle-right.svg?e8d4ef2b";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/angle-right.svg
// module id = 999
// module chunks = 8